module.exports = __webpack_public_path__ + "img/marcador.97888143.svg";